<template>
    <overlay-modal ref="overlayModal" width="30%">
        <template v-slot:header>
            <h2>Modifica ricerca</h2>
        </template>
        <template>
            <div class="modal-change-search container">
                <div>
                    <form>
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="aereoportoId">Aereoporto di partenza</label>
                                    <v-select class="form-control" id="aereoportoId" v-model="search.aereoporto" placeholder="Aereoporto di partenza" :options="list"/>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="partenzaId">Data di partenza il</label>
                                    <custom-date-picker id="partenzaId" v-model="search.partenza" :disabled-dates="disabledDatesPartenza"/>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="passeggeriId">Passeggeri</label>
                                    <camere-selector ref="camereSelectorRef" id="passeggeriId" v-model="search.camere"/>
                                </div>
                            </div>
                        </div>
                        <div class="buttons">
                            <button type="button" class="btn btn-primary orange" @click="onClick">Conferma modifiche</button>
                        </div>
                    </form>
                </div>
            </div>
        </template>
    </overlay-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import OverlayModal from '../../../../modals/OverlayModal'
import CustomDatePicker from '../../../common/CustomDatePicker'
import CamereSelector from '../../../common/CamereSelector'

export default {
  name: 'ModalChangeSearch',
  components: {CamereSelector, CustomDatePicker, OverlayModal},
  data () {
    return {
      search: this.getSearch()
    }
  },
  computed: {
    list: function () {
      return this.getTypesAereoporti().map(function (item) {
        return {label: item.name, value: item.id}
      })
    },
    disabledDatesPartenza: function () {
      const toDate = new Date()
      return {
        to: toDate
      }
    }
  },
  methods: {
    ...mapGetters(['getSearch', 'getTypesAereoporti']),
    ...mapActions(['addSearch']),
    open () {
      this.$refs.overlayModal.open()
    },
    close () {
      this.$refs.overlayModal.close()
    },
    onClick () {
      this.close()
      this.addSearch(this.search)
      this.$scrollTo('#app')
      this.$router.push('/experience-selection')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/experience/modals/ModalChangeSearch.vue